// extracted by mini-css-extract-plugin
module.exports = {"screen":"Screen_screen__1DofJ"};